'use strict';

define('lib/analytics/blocks/global.block',[
  'jquery',
  'lib/util/tda.config',
  'cookies',
  'lib/util/zip',
  'responsive'
], function (
  $,
  tdaConfig,
  cookies,
  zip,
  responsive
) {
  function __getComponents() {
    var comps = $('div[data-component-name]');
    var componentName = [];
    comps.each(function () {
      componentName.push($(this).data('componentName'));
    });
    return componentName.join(',');
  }

  function __getBreakpoint() {
    var curBreakpoint = responsive();
    // if we don't have a breakpoint (Timing!), we need to make our own
    if (curBreakpoint !== 'sm' || curBreakpoint !== 'md' || curBreakpoint !== 'lg') {
      var curWidth = window.innerWidth;
      if (curWidth < 768) {
        curBreakpoint = 'sm';
      } else if (curWidth >= 768 && curWidth < 960) {
        curBreakpoint = 'md';
      } else {
        curBreakpoint = 'lg';
      }
    }
    var map = {
      lg: 'Large',
      md: 'Medium',
      sm: 'Small'
    };
    return map[curBreakpoint] || 'unknown';
  }

  return function globalBlock() {
    return {
      tda_code: tdaConfig.tda.code,
      zipcode: cookies.getItem('isConfirmedZip') === 'true' ? zip.getCookiedDefaultFallback() : '',
      breakpoint: __getBreakpoint(),
      component_name: __getComponents()
    };
  };
});

